module.exports = __webpack_public_path__ + "img/bookmark-on.36a8f1fe.svg";